export default "__VITE_PUBLIC_ASSET__ed5b6060__"